import { FC } from 'react';
import { ResourceFolderIcon } from './ResourceFolderIcon';
import { useStyles } from './ResourceFolderItem.styles';

export interface ResourceFolderItemProps {
  name: string;
  count: number;
  color: string;
}

export const ResourceFolderItem: FC<ResourceFolderItemProps> = (props) => {
  const { name } = props;
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.containerIcon}>
        <ResourceFolderIcon {...props} />
      </div>
      <span className={styles.name}>{name}</span>
    </div>
  );
};
